export default __webpack_public_path__ + "static/media/Vcura.e9677b6f.JPG";